var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMultiFamily = function SvgMultiFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.804 4.472.996.962-.69.666L4.9 2.033.69 6.1 0 5.434 4.9.7l2.603 2.514V1.957h1.301v2.515ZM4.9 2.9l3.9 3.806V10.5H1V6.706L4.9 2.9Zm1.3 7V6.7H3.6v3.2h2.6Zm9.539-7.206.711.687-.493.476L12.95.952 9.943 3.857l-.493-.476L12.95 0l1.86 1.796V.898h.929v1.796ZM12.95 1.571l2.786 2.72V7h-5.572V4.29l2.786-2.719Zm.929 5V4.287H12.02V6.57h1.857Z",
    fill: "#fff"
  })));
};
export default SvgMultiFamily;